define('modules/base/views/model.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/base.view"
], function(
    Prospector,
    $,_,Backbone,Marionette,
    BaseView
){
    var BaseModelView = BaseView.extend({
        hasMoreAttr: 'hasMore',
        mEvents:function() {
            var base = {
            };
            return base;
        },
        debugName: 'Model View',
        modelSelector: '',
        filterSelector: '',
        loader: 'ripple',
        loaderHtml:'<div></div><div></div>',
        preLoadedContentSelector: '',
        mode: 'fetch',
        abortable: false,
        requiredLength: 2,
        initialize: function(options) {
            BaseView.prototype.initialize.call(this, options);
            this.queue= 0;
            this.query = '';
            this.buildModel();
        },
        buildModel:function(){
            this.model = new Backbone.Model();
        },
        onShow:function(){
            if(this.preLoadedContentSelector != '') {
                this.$(this.preLoadedContentSelector).hide();
            }
        },
        onRender: function() {
            if(this.filterSelector != ''){
                this.$(this.filterSelector).bind('keyup', $.proxy(this.querySearch, this));
            }
            this.$(this.mainBtnLoaderTextSelector).html(this.mainBtnLoaderRestingText);
            this.fetchModel();
        },
        fetchModel:function(){
            this.cleanMySubviews();
            this.addLoader();
            this.model.page = 1;
            //this.model.once('sync', this.procModel, this);
            this.listenToOnce(this.model, 'sync', this.procModel, this);
            if(this.abortable){
                if(this.currXHR != undefined && this.currXHR.readyState > 0 && this.currXHR.readyState < 4){
                    this.currXHR.abort();
                }
            }
            if(this.mode == 'fetch'){
                this.currXHR = this.model.fetch();
            } else
            if(this.mode == 'save'){
                this.currXHR = this.model.save();
            }
        },
        getLoaderDiv: function(){
            return this.modelSelector == this.el ? $(this.el) : this.$(this.modelSelector);
        },
        addLoader:function(){
            if(this.preLoadedContentSelector != '') {
                this.$(this.preLoadedContentSelector).hide();
                this.$(this.modelSelector).empty();
                this.$(this.loader).show();
            }else {
                var selector = this.getLoaderDiv();
                selector.empty();
                selector.append(this.loaderHtml);
                selector.addClass(this.loader);
            }

        },
        removeLoader:function(){
            if(this.preLoadedContentSelector != '') {
                this.$(this.preLoadedContentSelector).show();
                this.$(this.loader).hide();
            }else {
                var selector = this.getLoaderDiv();
                selector.empty();
                selector.removeClass(this.loader);
            }
        },
        procModel:function(){
            this.$('.postFirstLoad').show();
            this.removeLoader();
            if(this.model.has('error')){
                this.errOut(this.model.get('error').message);
                this.model.set({error: undefined});
            } else {
                this.procResponse();
            }
        },
        procResponse:function(){

        },
        /* Maintenance Functions */
        removeSubViewByView:function(view){
            if(this.subviews.length > 0){
                var index = this.subviews.indexOf(view);
                if(index > -1){
                    this.subviews.splice(index, 1);
                    view.unbind();
                    view.remove();
                }
            }
        },
        removeSubViewByModelId:function(modelId){
            var indRemove = new Array();
            _.each(this.subviews.reverse(), function(sv){
                if((sv.model.has != undefined && sv.model.has('id') && sv.model.get('id') ==  modelId) ||
                    (sv.model.id != undefined && sv.model.id ==  modelId))
                {
                    var index = this.subviews.indexOf(sv);
                    if(index > -1) {
                        sv.unbind();
                        sv.remove();
                        indRemove.push(index);
                    }
                }
            }, this);
            _.each(indRemove, function(index){
                this.subviews.splice(index, 1);
            }, this);
        },
        getInputString:function(){
            var newQuery = this.$(this.filterSelector).val();
            if (newQuery.length < this.requiredLength) {
                newQuery = "";
            }
            return $.trim(newQuery);
        },
        querySearch:function(event) {
            event.stopPropagation();
            var inp = String.fromCharCode(event.keyCode);
            if (/[a-zA-Z0-9-]/.test(inp) || event.keyCode == 8 || event.keyCode == 91 || event.keyCode == 32) {
                this.procSearch();
            }
        },
        procSearch:function() {
            var val = this.getInputString();
            if (this.lastQuery != val){
                window.setTimeout(
                    $.proxy(
                        this.procTimeBuildSearch,
                        this, val),
                    window.typeAheadWait + Math.ceil(100 * Math.random()));
            }
        },
        procTimeBuildSearch:function(val){
            var that = this;
            if(val == this.getInputString() && this.lastQuery != val){
                this.lastQuery = val;
                this.model.query = val == "" ? undefined : val;
                this.model.page = 1;
                this.fetchModel();
            }
        },
        removeModelByModelId:function(modelId){
            var models = this.model.get(this.modelCollection);
            var indRemove = new Array();
            _.each(models.reverse(), function(model){
                if((model.id!= undefined && model.id == modelId)
                    ||(model.has != undefined && model.has('id') && model.get('id')  == modelId))
                {
                    var index = models.indexOf(model);
                    if(index > -1) {
                        indRemove.push(index);
                    }
                }
            }, this);
            _.each(indRemove, function(index){
                models.splice(index, 1);
            }, this);
        }
    });
    return BaseModelView;
});

